import Vue from 'vue';

export default {
  reset(state) {
    state.contacts = {};
    state.users = {};
    state.filter = {};
  },

  updateContacts(state, contacts) {
    state.contacts = contacts;
  },

  updateContact(state, contact) {
    Vue.set(state.contacts, contact.id, contact);
  },

  updateContactFavorite(state, contact) {
    state.contacts[contact.id].isFavorite = contact.isFavorite;
  },

  removeContact(state, contact) {
    Vue.delete(state.contacts, contact.id);
  },

  // update single user
  updateUser(state, userDto) {
    Vue.set(state.users, userDto.username, userDto);
  },

  updateFilter(state, payload) {
    state.filter = {...state.filter, ...payload};
  },

  updateUserOnlineStatus(state, userDto) {
    let contact = state.contacts[userDto.id];
    let user = state.users[userDto.username];
    if (contact) {
      contact.isOnline = !!userDto.isOnline;
    }
    if (user) {
      user.isOnline = !!userDto.isOnline;
    }
  }
};
